<template>
    <div class="page">
        <box fill>
            <el-form label-position="right" label-width="80px" class="EL-Form">
                <el-col :lg="5" :xl="5">
                    <el-form-item label="通道编号" class="EL-Form-Item">
                        <el-input placeholder="请输入" v-model="pagination.whCode">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="类型" class="EL-Form-Item">
                        <el-input placeholder="请输入" v-model="pagination.type">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="类型名称" class="EL-Form-Item">
                        <el-input placeholder="请输入" v-model="pagination.typeName">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="是否拉动" class="EL-Form-Item">
                        <el-select v-model="pagination.pullFlag" clearable="clearable">
                            <el-option label="是" value="true"></el-option>
                            <el-option label="否" value="false"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="4" :xl="4">
                    <el-form-item class="btn-edit-delete EL-Form-Item">
                        <el-button class="btn-t-edit" @click="getAuxiMaterialData()">
                            查询
                        </el-button>
                        <el-button class="btn-t-delete" @click="resetData()">
                            重置
                        </el-button>
                    </el-form-item>
                </el-col>
            </el-form>
            <el-divider></el-divider>
            <plabel text="类型拉动配置">
                <el-button :loading="!!loading" v-authority="'BACK_MENU5_M17_B1'" class="btn-t-edit" @click="(add_or_edit = true), (editBoxShow = true)">新增</el-button>
                <el-button v-authority="'BACK_MENU5_M17_B4'" :loading="downloadLoading" class="btn-t-edit" type="primary" @click="downLoadFile()">导出EXCEL</el-button>
            </plabel>
            <!-- 展示 -->
            <h-table v-loading="loading" :headerCellStyle="headerCellStyle" style="flex: 1" @pageChange="getAuxiMaterialData" :data="mainData" pagination :nowPage.sync="pagination.pageNum" :pageSize.sync="pagination.pageSize" :total.sync="tableTotal">
                <el-table-column prop="whCode" label="通道编号" />
                <el-table-column prop="type" label="类型" />
                <el-table-column prop="typeName" label="类型名称" />
                <el-table-column prop="pullFlag" label="是否拉动">
                    <template slot-scope="scope">
                        <span v-if="scope.row.pullFlag == true">是</span>
                        <span v-if="scope.row.pullFlag == false">否</span>
                    </template>
                </el-table-column>
                <el-table-column prop="maxMatQuan" label="最大库存数" />
                <el-table-column prop="minMatQuan" label="最小库存数" />
                <el-table-column prop="createTime" label="创建时间" />
                <el-table-column prop="updateTime" label="修改时间" />
                <el-table-column label="操作" width="150">
                    <template slot-scope="scope">
                        <el-button v-authority="'BACK_MENU5_M17_B2'" :disabled="scope.row.mtXa ? true : false" size="mini" type="primary" @click="
                (add_or_edit = false),
                  (editBoxShow = true),
                  (mainObj = JSON.parse(JSON.stringify(scope.row)))
              " plain icon="el-icon-edit-outline" />
                        <el-button v-authority="'BACK_MENU5_M17_B3'" type="danger" @click="deleteRow(scope.row)" size="mini" plain icon="el-icon-delete" />
                    </template>
                </el-table-column>
            </h-table>
        </box>

        <!-- 新增&&编辑框 -->
        <el-dialog :title="add_or_edit ? '新增' : '编辑'" :close-on-click-modal="false" :visible.sync="editBoxShow" :model="mainObj" @open="open" :style="$popups.popups(0.5,0.6)" class="fromDialog">
            <span class="formClass">
                <el-form :inline="true" label-position="top" label-width="80px" :model="mainObj" :rules="rules" ref="mainObj">
                    <el-col :lg="8" :xl="8">
                        <el-form-item label="通道编号" prop="whCode" class="EL-Form-Item">
                            <el-input v-model.trim="mainObj.whCode" maxlength="20"> </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="8" :xl="8">
                        <el-form-item label="类型" prop="type" class="EL-Form-Item">
                            <el-input v-model.trim="mainObj.type" maxlength="50"> </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="8" :xl="8">
                        <el-form-item label="类型名称" prop="typeName" class="EL-Form-Item">
                            <el-input v-model="mainObj.typeName" maxlength="50"> </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="8" :xl="8">
                        <el-form-item label="是否拉动" prop="pullFlag" class="EL-Form-Item">
                            <el-select v-model="mainObj.pullFlag" placeholder="请选择" clearable="clearable">
                                <el-option label="是" :value="true"></el-option>
                                <el-option label="否" :value="false"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="8" :xl="8">
                        <el-form-item label="最大库存数" prop="maxMatQuan" class="EL-Form-Item">
                            <el-input-number v-model="mainObj.maxMatQuan" :min="1"></el-input-number>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="8" :xl="8">
                        <el-form-item label="最小库存数" prop="minMatQuan" class="EL-Form-Item">
                            <el-input-number v-model="mainObj.minMatQuan" :min="0"></el-input-number>
                        </el-form-item>
                    </el-col>
                </el-form>
            </span>
            <span slot="footer" class="dialog-footer footer-bottom">
                <el-button size="small" type="info" @click="editBoxShow = false">
                    取 消
                </el-button>
                <el-button size="small" type="primary" v-if="add_or_edit" @click="add">
                    新 增
                </el-button>
                <el-button size="small" type="primary" v-else @click="editRow">
                    修 改
                </el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: "StockCheckTaskDetail",
    data() {
        return {
            headerCellStyle: () => {
                return "background-color: #1f5cec";
            },
            form: {},
            rules: {
                whCode: [{
                    required: true,
                    message: "请输入",
                    trigger: "blur",
                }, ],
                type: [{
                    required: true,
                    message: "请输入",
                    trigger: "blur",
                }, ],
                typeName: [{
                    required: true,
                    message: "请输入",
                    trigger: "blur",
                }, ],
                pullFlag: [{
                    required: true,
                    message: "请选择",
                    trigger: "blur",
                }, ],
                maxMatQuan: [{
                    required: true,
                    message: "请输入",
                    trigger: "blur",
                }, ],
                minMatQuan: [{
                    required: true,
                    message: "请输入",
                    trigger: "blur",
                }, ],
                
            },

            mtTypeList: [], //物料类型集合

            showRoleBox: true,
            add_or_edit: Boolean, //新增|编辑
            editBoxShow: false, //编辑框
            dialogFormVisible: false,
            formLabelWidth: "140px", // 对话框大小
            tableHeight: 0, //表格高度
            testValue: 1,
            mainObj: {},
            pagination: {
                pageSize: 50,
                pageNum: 1,
                mtCode: "",
                mtName: "",
                fcCode: localStorage.getItem("fcCode") || "",
                mtCheck: ""
            },
            tableTotal:0,
            mainData: [],
            fcode: localStorage.getItem("fcCode") || "",

            downloadLoading: false, //下载中

            loading: 0,

            logContent: "", //操作日志-内容
            logRemarks: "", //操作日志-备注
            // 输入框延时加载
            isSetTimeout: null,
        };
    },
    watch: {
        pagination: {
            handler(newVal) {
                clearTimeout(this.isSetTimeout)
                this.isSetTimeout = setTimeout(() => {
                    this.getAuxiMaterialData(newVal);
                }, 1000)
            },
            deep: true,
        },
    },
    methods: {
        //获取数据
        getAuxiMaterialData() {
            // this.loading++
          var paramsObj = {
            pageSize: this.pagination.pageSize,
            pageNum: this.pagination.pageNum,
            whCode: this.pagination.whCode,
            type: this.pagination.type,
            typeName: this.pagination.typeName,
            pullFlag: this.pagination.pullFlag,
          }
            this.$http
                .request({
                    url: "/api/channelPullConfiguration/getChannelPullConfigurationList",
                    method: "GET",
                    params: paramsObj,
                })
                .then((resp) => {
                    // this.loading--
                    if (resp.status == 100) {
                        // console.log(resp.data.list.length);
                        this.mainData = resp.data.list || [];
                        this.tableTotal = resp.data.total;
                    }
                })
                .catch((error) => {
                    // this.loading--;
                });
        },
        //获取类型
        getmtTypeList() {
            this.$http.request({
                url: "/api/dictData/getDictData",
                method: "GET",
                showLoading: true,
                params: {
                    ddCode: "MDTYPE",
                },
            }).then((resp) => {
                if (resp.status == 100) {
                    this.mtTypeList = resp.data.list || [];
                }
            }).catch((error) => {});
        },

        //表单验证
        submitForm(formName) {
            let r = Boolean;
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    r = true;
                } else {
                    r = false;
                }
            });
            return r;
        },
        //框打开
        open() {
            if (this.add_or_edit) {
                //新增
                this.mainObj = JSON.parse(JSON.stringify({}));
            } else {
                this.getAuxiMaterialData();
            }
        },
        //新增
        add() {
            if (this.fcode != "") {
                this.mainObj.fcCode = this.fcode;
            }
            if (this.submitForm("mainObj")) {
                this.$http
                    .request({
                        url: "/api/channelPullConfiguration/insertChannelPullConfiguration",
                        method: "POST",
                        showLoading: true,
                        data: this.mainObj,
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.$notify({
                                title: "成功",
                                message: "新增成功！",
                                type: "success",
                            });
                            this.logRemarks = "channelPullConfiguration：类型拉动配置新增成功";
                        } else {
                            this.$notify.error({
                                title: "失败",
                                message: resp.message,
                            });
                            this.logRemarks = "channelPullConfiguration：类型拉动配置新增失败";
                        }
                        this.logContent =
                            "type:" +
                            this.mainObj.type +
                            "\t typeName:" +
                            this.mainObj.typeName;
                        this.systemLog();
                        this.editBoxShow = false;
                        this.getAuxiMaterialData();
                    })
                    .catch((error) => {
                        this.$notify.error({
                            title: "失败",
                            message: "调用失败",
                        });
                    });
            }
        },
        //编辑
        editRow() {
            if (this.submitForm("mainObj")) {
                this.$http
                    .request({
                        url: "/api/channelPullConfiguration/updateChannelPullConfiguration",
                        method: "POST",
                        showLoading: true,
                        data: this.mainObj,
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.$notify({
                                title: "成功",
                                message: "修改成功！",
                                type: "success",
                            });
                            this.logRemarks = "channelPullConfiguration：类型拉动配置编辑成功";
                        } else {
                            this.$notify.error({
                                title: "失败",
                                message: resp.message,
                            });
                            this.logRemarks = "channelPullConfiguration：类型拉动配置编辑失败";
                        }
                        this.logContent =
                            "type:" +
                            this.mainObj.type +
                            "\t typeName:" +
                            this.mainObj.typeName;
                        this.systemLog();
                        this.editBoxShow = false;
                        this.getAuxiMaterialData();
                    })
                    .catch((error) => {
                        this.$notify.error({
                            title: "失败",
                            message: "调用失败",
                        });
                    });
            }
        },
        //删除
        deleteRow(row) {
            this.$confirm("此操作将删除该数据, 是否继续?", "提示", {
                confirmButtonText: "删除",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.$http
                        .request({
                            url: "/api/channelPullConfiguration/deleteChannelPullConfiguration",
                            method: "DELETE",
                            showLoading: true,
                            data: row,
                        })
                        .then((resp) => {
                            if (resp.status == 100) {
                                this.$notify({
                                    title: "成功",
                                    message: "删除成功！",
                                    type: "success",
                                });
                                this.logRemarks = "channelPullConfiguration：类型拉动配置删除成功";
                            } else {
                                this.$notify.error({
                                    title: "失败",
                                    message: "删除失败",
                                });
                                this.logRemarks = "channelPullConfiguration：类型拉动配置删除失败";
                            }
                            this.logContent = "row.cpcId" + row.cpcId;
                            this.systemLog();
                            this.getAuxiMaterialData();
                        })
                        .catch((error) => {
                            this.$notify.error({
                                title: "失败",
                                message: "调用失败",
                            });
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除",
                    });
                });
        },

        //重置
        resetData() {
            this.pagination = {
                pageSize: 50,
                pageNum: 1,
                mtCode: "",
                mtName: "",
                fcCode: localStorage.getItem("fcCode") || "",
                mtCheck: ""
            };
            this.tableTotal=0;
            // this.getAuxiMaterialData();
        },

        //表格导出
        downLoadFile() {
            this.downloadLoading = true;
            var paramsObj = {
                whCode: this.pagination.whCode,
                type: this.pagination.type,
                typeName: this.pagination.typeName,
                pullFlag: this.pagination.pullFlag,
                pageNum: 1,
                pageSize: 999999,
            }

            this.$http.request({
                url: '/api/channelPullConfiguration/getChannelPullConfigurationList',
                method: 'GET',
                showLoading: true,
                params: paramsObj
            }).then((resp) => {
                resp.status == 100 ? this.downLoad(resp.data.list || []) : this.$notify.error({
                    message: '查询失败'
                });
            })
        },
        downLoad(list) {
            import('@/libs/Export2Excel').then(excel => {
                list.forEach(function(c) {
                    // if (c.mtCheck == '10') {
                    //     c['mtCheck'] = '全检'
                    // } else if (c.mtCheck == '20') {
                    //     c['mtCheck'] = '免检'
                    // } else if (c.mtCheck == '30') {
                    //     c['mtCheck'] = '抽检'
                    // }

                    if (c.pullFlag == true) {
                        c['pullFlag'] = '是'
                    } else if (c.pullFlag == false) {
                        c['pullFlag'] = '否'
                    }
                })
                const tHeader = ['通道编号', '类型', '类型名称', '是否拉动', '最大库存数', '最小库存数', '创建时间', '修改时间']
                const filterVal = ['whCode', 'type', 'typeName', 'pullFlag', 'maxMatQuan', 'minMatQuan', 'createTime', 'updateTime']
                const data = this.formatJson(filterVal, list)
                excel.export_json_to_excel({
                    header: tHeader,
                    data,
                    filename: '类型拉动配置数据'
                })
                this.logContent = "导出"
                this.logRemarks = "channel_pull_configuration：导出类型拉动配置数据"
                this.systemLog();
                this.downloadLoading = false
            })
        },
        formatJson(filterVal, jsonData) {
            return jsonData.map(v => filterVal.map(j => v[j]))
        },


        /**
         * 操作日志
         */
        systemLog() {
            let objData = {
                logType: "类型拉动配置主数据",
                logContent: this.logRemarks || "",
                //logRemarks: this.logRemarks || "",
                logUser: localStorage.getItem("user") || "",
            };
            this.$http
                .request({
                    url: "api/log/insert",
                    method: "POST",
                    data: objData,
                })
                .then((resp) => {
                    this.logContent = "";
                    this.logRemarks = "";
                    if (resp.status == 100) {}
                })
                .catch((error) => {});
        },
    },
    activated() {
        this.getmtTypeList()
        /* 获取首页的数据 */
        this.getAuxiMaterialData();
    },
};
</script>

<style scoped>
</style>